import React from 'react';
import StoreIcon from './StoreIcon';

const StoreIcons = ({ langCode }) => {
  const downloadAppString =
    {
      'en-US': 'Download app',
      'it-IT': "Scarica l'app",
    }[langCode] || '';
  return (
    <div className='footer__download-bar'>
      <a className='footer__download-bar--text' href='/mycattolica-download'>
        {downloadAppString}
      </a>
      <StoreIcon
        name='Apple App Store'
        url='https://apps.apple.com/it/app/mycattolica/id1625097487'
      />
      <StoreIcon
        name='Google Play Store'
        url='https://play.google.com/store/apps/details?id=it.cattolicaassicurazioni.android.mycattolica&pli=1'
      />
    </div>
  );
};

export default StoreIcons;
